var Switch = (function (options) {

    var _currentState = null;

    var defaultOptions = {
        selectedClass: 'switch-option__selected',
        testClass: '',
        defaultValue: true,
        trueText: '',
        falseText: '',
        label: '',
        labelPosition: 'right', // 'left'
        onChanged: null
    };

    var o = $.extend({}, defaultOptions, options);

    var $el = $.tmpl('switch_' + o.labelPosition.toLowerCase(), { true_text: o.trueText, false_text: o.falseText, label: o.label, test_class: o.testClass });
    var $option_true = $('@switch-option_true', $el);
    var $option_false = $('@switch-option_false', $el);
    
    var _updateState = function (state) {
        var callChangedFunc = (_currentState == null && state != null || _currentState != state) && $.isFunction(o.onChanged);
        _currentState = state;
        state === true && $option_true.addClass(o.selectedClass) || $option_true.removeClass(o.selectedClass);
        state === false && $option_false.addClass(o.selectedClass) || $option_false.removeClass(o.selectedClass);
        $el.attr('state', _currentState);
        callChangedFunc && o.onChanged(_currentState);
    }

    _updateState(o.defaultValue);

    $option_true.on('click', function () {
        _updateState(true);
    });

    $option_false.on('click', function () {
        _updateState(false);
    });

    return {
        appendTo: function ($container) {
            $container.append($el);
        },
        getValue: function () {
            return _currentState;
        },
        setValue: function (value) {
            _updateState(!!value);
        },
        setValueNoCast: function (value) {
            _updateState(value);
        },
        toggleWarningClass: function (state) {
            $el.find('.switch').toggleClass('errorField', state);
        },
        remove: function() {
            $el && $el.remove();
        }
    };
});